import { Truck, Search, DollarSign, Zap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import type { TKey } from "@/i18n/translations";

const items: { icon: typeof Truck; key: TKey }[] = [
  { icon: Truck, key: "trust.1" },
  { icon: Search, key: "trust.2" },
  { icon: DollarSign, key: "trust.3" },
  { icon: Zap, key: "trust.4" },
];

const TrustStrip = () => {
  const { t } = useLang();
  return (
    <section className="border-b border-border bg-foreground py-10 md:py-20">
      <div className="container">
        <h2 className="text-center text-xl font-bold tracking-tight text-background sm:text-2xl md:text-3xl">
          {t("trust.h2")}
        </h2>

        <div className="mx-auto mt-8 grid max-w-6xl gap-3 sm:mt-10 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4 lg:gap-6">
          {items.map(({ icon: Icon, key }) => (
            <div
              key={key}
              className="flex h-full items-start gap-3 rounded-xl border border-background/15 bg-background/[0.07] p-5 backdrop-blur-sm transition-colors hover:bg-background/10"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-background text-foreground">
                <Icon className="h-4.5 w-4.5" strokeWidth={2.25} />
              </span>
              <p className="text-sm font-medium leading-relaxed text-background">
                {t(key)}
              </p>
            </div>
          ))}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-xs font-medium leading-relaxed text-background/70 sm:mt-10 sm:text-sm">
          {t("trust.footer")}
        </p>
      </div>
    </section>
  );
};

export default TrustStrip;
